// extracted by mini-css-extract-plugin
export default {"root":"hcx-card-tabs_root__C4Apc"};